export default __webpack_public_path__ + "d71011b0acb5cc04d6f91fd0a513ad31.svg";